import axiosInstance from 'api/axios'
import {
  ICaregiverEntitlement,
  IFamilyMemberDto,
  IGetMySubscriptionGroupResponse,
} from 'types/subscription.types'

/**
 * Owner + member can read their group: entitlement + visible (invited/active) members.
 * For non-family caregivers backend still returns entitlement with familyContext = null and members = [].
 */
export const getMySubscriptionGroup = (): Promise<{ data: IGetMySubscriptionGroupResponse }> => {
  return axiosInstance.post('/subscription-groups/my')
}

/** Owner removes a member (or invited row) from the Family group. */
export const removeFamilyMember = (memberId: number): Promise<{ data: { success: true } }> => {
  return axiosInstance.post('/subscription-groups/remove-member', { memberId })
}

export type { ICaregiverEntitlement, IFamilyMemberDto, IGetMySubscriptionGroupResponse }
